import React from 'react';
import { IconProps } from '.';

const SvgColoredHomeSet = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#FFD743'
        d='M22.76 10.992c.513.491.15 1.33-.578 1.33h-2.04a2.264 2.264 0 0 0-1.667-.725h-.71c-1.02 0-1.847.66-2.163 1.54-.961-.174-1.923.314-2.383 1.146l-.375.658-.024.048a2.446 2.446 0 0 0 .293 2.599c-.617.723-.781 1.795-.226 2.7l.342.6.003.006c.322.555.864.959 1.475 1.106H5.382a1.595 1.595 0 0 1-1.591-1.6v-8.078H1.818c-.727 0-1.091-.839-.577-1.33l10.182-8.764a.844.844 0 0 1 1.154 0l10.182 8.764Z'
      />
      <path
        fill='#262829'
        d='m21.64 18.4-.428-.262c-.464-.3-.464-1.013 0-1.313l.428-.262c.357-.226.464-.675.25-1.013l-.357-.638c-.214-.375-.642-.487-.963-.262l-.429.262c-.464.3-1.07-.075-1.07-.637v-.525c0-.412-.322-.75-.714-.75h-.714c-.393 0-.714.338-.714.75v.488c0 .562-.606.937-1.07.637l-.429-.225a.674.674 0 0 0-.963.262l-.357.638c-.179.375-.071.825.25 1.05l.428.262c.464.263.464 1.013 0 1.276l-.428.262c-.357.225-.464.675-.25 1.013l.357.637c.214.375.642.488.963.262l.429-.225c.464-.3 1.07.076 1.07.638v.525c0 .413.322.75.714.75h.714c.393 0 .714-.337.714-.75v-.488c0-.562.606-.937 1.07-.637l.429.262a.674.674 0 0 0 .963-.262l.357-.637c.179-.413.072-.863-.25-1.088ZM18 19c-.785 0-1.428-.675-1.428-1.5S17.215 16 18 16c.785 0 1.428.675 1.428 1.5S18.785 19 18 19Z'
      />
    </svg>
  );
};

export default SvgColoredHomeSet;
